<template>
  <a-modal
    class="template-delete-modal"
    :title="$t('TP_Delete_1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        class="delete-btn"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("Common_Delete")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-text">
      <div>{{$t("TP_Delete_4")}}</div>
      <div>{{$t("TP_Delete_5")}}</div>
    </div>
    <div class="content-group">
      <ul>
        <li>
          <span class="title">No</span>
          <span class="value">{{ templateInfo.templateNo }}</span>
        </li>
        <li>
          <span class="title">{{$t("TP_Col_TemplateNm")}}</span>
          <span class="value">{{ templateInfo.templateName }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_RegDate")}}</span>
          <span class="value">{{
            timeFormatFromUTCEpoch(templateInfo.regEpoch)
          }}</span>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch } from "@/utils/common";

export default {
  name: "TemplateDeleteModal",
  props: {
    visible: Boolean,
    templateInfo: Object,
    toggleModal: Function,
  },
  setup(props) {
    const store = useStore();
    const loading = ref(false);

    // 삭제 버튼 이벤트
    const handleOk = async () => {
      loading.value = true;

      try {
        const response = await axios.delete(apiUrl + "Template", {
          params: { templateNo: props.templateInfo.templateNo },
        });
        if (response && !response.data.error) {
          store.dispatch("template/DELETE_TEMPLATE", response);
        }
      } catch (error) {
        console.log("error", error);
      }
      loading.value = false;
      props.toggleModal();
    };

    const handleCancel = () => {
      props.toggleModal();
    };

    return {
      handleOk,
      handleCancel,
      loading,
      timeFormatFromUTCEpoch,
    };
  },
};
</script>